<template>
  <t-form labelWidth="90px" class="cpt-tree-otpion-wrap">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <e-collapse title="基础属性" :expand="false">
      <t-form-item label="文字行高">
        <t-input-number v-model="attribute.fontLineHeight" size="small" :min="0" :max="10000" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="文字大小">
        <t-input-number v-model="attribute.fontSize" size="small" :min="10" :max="100" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="字体">
        <t-select v-model="attribute.textFamily" size="small">
          <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value" />
        </t-select>
      </t-form-item>
      <t-form-item label="文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.fontColor" :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="背景颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.backgroundColor"
          :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="滚动条背景色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.scrollBgColor"
          :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="滚动条颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.scrollColor"
          :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="滚动条宽度">
        <t-input-number v-model="attribute.scrollWidth" size="small" :min="1" :max="1000" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="初始化展开">
        <t-switch v-model="attribute.expandAll" :label="['展开', '收起']" size="small" />
      </t-form-item>
      <t-form-item label="展开动画">
        <t-switch v-model="attribute.transition" :label="['开', '关']" size="small" />
      </t-form-item>

      <t-form-item label="显示图标">
        <t-switch v-model="attribute.showIcon" :label="['显示', '隐藏']" size="small" />
      </t-form-item>
      <t-form-item label="显示连接线">
        <t-switch v-model="attribute.showLine" :label="['显示', '隐藏']" size="small" />
      </t-form-item>
      <t-form-item label="连接线颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.lineColor" :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="禁止父级点击">
        <t-switch v-model="attribute.isFatherClick" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="默认选中">
        <t-switch v-model="attribute.isDefault" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="开启拖拽">
        <t-switch v-model="attribute.draggable" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="开启过滤">
        <t-switch v-model="attribute.filter" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="互斥展开">
        <t-switch v-model="attribute.mutex" :label="['开', '关']" size="small" />
      </t-form-item>

    </e-collapse>
    <e-collapse title="高亮" :expand="false">
      <t-form-item label="开启高亮">
        <t-switch v-model="attribute.activable" :label="['开', '关']" size="small" />
      </t-form-item>
      <template v-if="attribute.activable">
        <t-form-item label="高亮多选">
          <t-switch v-model="attribute.activeMultiple" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="整个节点高亮">
          <t-switch v-model="attribute.expandOnClickNode" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="高亮背景色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" :enable-alpha="true"
            v-model="attribute.activableBgColor" size="small" />
        </t-form-item>
        <t-form-item label="高亮字体色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" :enable-alpha="true"
            v-model="attribute.activableFontColor" size="small" />
        </t-form-item>
        <t-form-item label="高亮字体大小">
          <t-input-number v-model="attribute.activableFontSize" size="small" :min="10" :max="100" :decimal-places="0" />
        </t-form-item>
      </template>
    </e-collapse>
    <e-collapse title="选择" :expand="false">
      <t-form-item label="开启选择">
        <t-switch v-model="attribute.checkable" :label="['开', '关']" size="small" />
      </t-form-item>
      <t-form-item label="开启地图定位">
        <t-switch v-model="attribute.mapPoint" :label="['开', '关']" size="small" />
      </t-form-item>

      <template v-if="attribute.checkable">
        <t-form-item label="默认全选">
          <t-switch v-model="attribute.initChecked" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="父子关联">
          <t-switch v-model="attribute.checkStrictly" :label="['开', '关']" size="small" />
        </t-form-item>
        <t-form-item label="选择框选中背景色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.checkableBgColor"
            :enable-alpha="true" />
        </t-form-item>
        <t-form-item label="选择框选中色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.checkableColor"
            :enable-alpha="true" />
        </t-form-item>
        <t-form-item label="选择框背景色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.checkableBgColorAll"
            :enable-alpha="true" />
        </t-form-item>
        <t-form-item label="选择框边框色">
          <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.checakableBorderAll"
            :enable-alpha="true" />
        </t-form-item>
        <t-form-item label="选择框形状">
          <t-select v-model="attribute.checkableStyle">
            <t-option key="default" label="正方形" value="default" />
            <t-option key="radius" label="圆形" value="radius" />
          </t-select>
        </t-form-item>
      </template>
    </e-collapse>
    <e-collapse title="无数据" :expand="false">
      <t-form-item label="文字信息">
        <t-input v-model="attribute.emptyText" size="small" />
      </t-form-item>
      <t-form-item label="文字大小">
        <t-input-number v-model="attribute.emptyFontSize" size="small" :min="10" :max="100" :decimal-places="0" />
      </t-form-item>
      <t-form-item label="文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="RGBA" v-model="attribute.emptyColor"
          :enable-alpha="true" />
      </t-form-item>
      <t-form-item label="文字位置">
        <div style="display: flex;width: 100%;">
          <t-tooltip content="左对齐">
            <t-icon @click="attribute.emptyPosition = 'start'"
              :class="{ 'emptyPosition': true, 'emptyPosition-active': attribute.emptyPosition == 'start' }"
              name="format-horizontal-align-top" />
          </t-tooltip>
          <t-tooltip content="居中">
            <t-icon @click="attribute.emptyPosition = 'center'"
              :class="{ 'emptyPosition': true, 'emptyPosition-active': attribute.emptyPosition == 'center' }"
              name="format-horizontal-align-center" />
          </t-tooltip>
          <t-tooltip content="右对齐">
            <t-icon @click="attribute.emptyPosition = 'end'"
              :class="{ 'emptyPosition': true, 'emptyPosition-active': attribute.emptyPosition == 'end' }"
              name="format-horizontal-align-bottom" />
          </t-tooltip>




        </div>
      </t-form-item>



    </e-collapse>
    <e-collapse title="自定义图标" :expand="false">

      <t-form-item label="开启图标">
        <t-switch v-model="attribute.isOpenImage" :label="['开', '关']" size="small" />
      </t-form-item>
      <template v-if="attribute.isOpenImage">
        <t-form-item label="父级图标">
          <div class="image-wrap">
            <t-image @click="opened('parent')" style="width: 100%;height: 100%;background: none"
              :src="imageUrl('parentImageUrl')" fit="fill" />
          </div>
        </t-form-item>
        <t-form-item label="子级图标">
          <div class="image-wrap">
            <t-image @click="opened('children')" style="width: 100%;height: 100%;background: none"
              :src="imageUrl('childrenImageUrl')" fit="fill" />
          </div>

        </t-form-item>
      </template>





    </e-collapse>
    <gallery ref="gallery" @confirmCheck="confirmCheck" />

  </t-form>
</template>

<script>
import EColorGroup from "@/components/designer/e-color-group.vue";
import Gallery from "@/components/designer/gallery";
import CptData from '@/components/element/options/comp/cpt-data'
import { fileUrl } from '/env'
export default {
  name: "cpt-tree-option",
  components: { EColorGroup, Gallery, CptData },
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  data() {
    return {
      fileUrl,
      type: null,
      textFamilyList: [],
    }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
  },
  computed: {
    imageUrl() {
      return image => this.fileUrl + this.attribute[image]
    }
  },
  methods: {
    opened(type) {
      this.type = type
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl) {
      this.attribute[`${this.type}ImageUrl`] = fileUrl
    }
  }

}
</script>

<style scoped>
.emptyPosition {
  margin-right: 15px;
  transform: rotate(-90deg);
  cursor: pointer;
  font-size: 16px;
}

.emptyPosition-active {
  color: rgb(38, 132, 255);
}

.cpt-tree-otpion-wrap .image-wrap {
  width: 80px;
  height: 80px;
  cursor: pointer;
}
</style>